/**
 *
 * @module AdvertisingPluginEvents enum
 * @desc Ad evnt enum
 *
 */
export default {
    AD_AUTOPLAY_BLOCKED: 'adAutoPlayBlocked',
    AD_PLUGIN_LOADED: 'adPluginLoaded',
    AD_REQUEST_STARTED: 'adRequestStarted',
    AD_REQUEST_COMPLETE: 'adRequestComplete',
    AD_PLUGIN_ERROR: 'adPluginError',
    AD_ERROR: 'adError',
    AD_START: 'adStart',
    AD_COMPLETE: 'adComplete',
    AD_PREROLL_START: 'adPreRollStart',
    AD_PREROLL_COMPLETE: 'adPreRollComplete',
    AD_DEFAULT_COMPANION: 'adDefaultCompanion',
    AD_COMPANION: 'adCompanion',
    AD_TIME_UPDATE_ELAPSED: 'adTimeUpdateElapsed',
    AD_TIME_UPDATE_REMAINING: 'adTimeUpdateRemaining',
    AD_BLOCK_DETECTED: 'adBlockDetected',
    ALL_ADS_COMPLETED: 'allAdsCompleted',
    AD_LOADED: 'adLoaded',
};
